<template>
    
    <div class="bg-light text-end mb-1" style="font-size: smaller;">
        <i class="fa fa-location-dot"></i> {{ data['address'] }} - <i class="fa fa-phone"></i> {{ data['phone'] }}
    </div>
    <div class="bg-light py-1 rounded-bottom">
        <router-link to="/" class="row" style="width: fit-content;text-decoration: none; margin-left: 5%;">
            <img :src="data['url']" style="width: auto;max-width: 100px;width: 15vw; aspect-ratio: 1; padding: 0" >
            <div class="d-flex align-items-start justify-content-center" style="width: auto;flex-direction: column;">
                <div style="color: blue;">{{ data['sub'] }}</div>
                <div style="font-size: 30px;color: red;font-weight: bolder;">{{ data['name'] }}</div>
            </div>
        </router-link>
        
    </div>
    
</template>

<script>
    import { ref, onValue } from "firebase/database";
    import { database } from '../../components/firebase'

    export default{
        props:['name'],
        data(){
            return{
                data:[]
            }
        },
        mounted(){
            const HeadderRef = ref(database, 'Header/');
            onValue(HeadderRef, (snapshot) => {
                this.data = snapshot.val();
                // console.log(this.data);
            });
        }
    }
</script>